//desc: this is the content page that is used to display the 3d model and animations of the project
import * as THREE from "three";
import { useEffect, useState } from "react";
import "../css/style.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";
import Contentscene from "../js/Scenes/Contentscene";
import nullstatic from "../images/Static.gif";
import objectgif from "../images/object.gif";
import WaveSurfer from "wavesurfer.js";
import { Navbar, Downloadmenu } from "./Props";
import Contenterrorscene from "../js/Scenes/ContentErrorscene";
import { SSGIEffect, TRAAEffect, MotionBlurEffect, VelocityDepthNormalPass} from "realism-effects"
import * as postprocessing from "postprocessing";

let scene, renderer;
let mixer, clips;
let menu
let loadingmanager = new THREE.LoadingManager();
export default function Content() {
  window.onload = () => Init();
  let [data, setData] = useState([]);
  let [link, setLink] = useState('');
  let id = new URLSearchParams(window.location.search).get("id");

  let returnvar = "/";
  let isbacktolist = new URLSearchParams(window.location.search).get(
    "Backtocontentlisting"
  );
  

  if (isbacktolist === "true") {
    returnvar = "/Contentlist";
  }
  loadingmanager.onLoad = function () {
    document.getElementById("loadingcover").style.display = "none";
  };
  loadingmanager.onProgress = function () {
    document.getElementById("loadingcover").style.display = "inline";
  };
  useEffect(() => {
    const q = query(
      collection(db, "Projects"),
      where("id", "==", parseInt(id))
    );
    getDocs(q).then((querySnapshot) => {
      setData(querySnapshot.docs.map((doc) => doc.data()));
    });
  }, [id]);

  const iconref = ref(
    storage,
    "Content/" + id + "/icon.png"
  );
  getDownloadURL(iconref)
    .then((url) => {
      const img = document.getElementById("icon");
      img.setAttribute("src", url);
    })
    .catch((error) => {
    });



  function Init() {
    window.createImageBitmap = undefined;
    const width = window.innerWidth,
      height = window.innerHeight;
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);

    const backgroundref = ref(
      storage,
      "Content/" + id + "/background.glb"
    );  

    const audioref = ref(
      storage,
      "Content/" + id + "/audio.mp3"
    );  
    
    getDownloadURL(backgroundref).then((url) => {
      scene = new Contentscene(url, loadingmanager);
    }).catch((error) => {
      scene = new Contenterrorscene(renderer, loadingmanager);
    });

    getDownloadURL(audioref).then((url) => {
      setLink(url);
    }).catch((error) => {
    });


    window.addEventListener("resize", onWindowResize, false);
    appendWebglcon();
    animate();

  }

  // animation
  function animate() {
    requestAnimationFrame(animate);
    if (!mixer && scene) {
      mixer = new THREE.AnimationMixer(scene);
    }
    if (scene && scene.camera) {
      
      renderer.render(scene, scene.camera);
    }
    if (mixer) {
      if (scene.reel) {
        clips = scene.reel;
        for (let i = 0; i < clips.length; i++) {
          mixer.clipAction(clips[i]).play();
        }
      }
      mixer.update(0.01);
    }

  }
function onWindowResize() {
    if (scene && scene.camera) {
      scene.camera.aspect = window.innerWidth / window.innerHeight;
      scene.camera.updateProjectionMatrix();
  
      renderer.setSize(window.innerWidth, window.innerHeight);

    }

  }
  async function appendWebglcon() {
    document.getElementById("root").appendChild(renderer.domElement);
    renderer.domElement.classList.add("renderer-2nd");
    renderer.domElement.id = "webgl";

  }

  function Info() {
    return <ul>
      <li>
        Id: {data[0].id}
      </li>
      <li>
        Name: {data[0].name}
      </li>
      <li>
        Tags: {data[0].tags}
      </li>
    </ul>;
  }

  if (data.length > 0) {
    return (
      <>
        <Navbar fixed="true"></Navbar>

        <div className="loadingcovercontent" id="loadingcover">
          <div className="text">
            <h1 className="">Loading...</h1>
          </div>
        </div>
        <div className="coverpage disablescroll">
          <div className="contentpage">
            <div className="backdiv">
              <a href={returnvar}>
                <div className="backbutton">
                  <h3 className="centerelements">Back</h3>
                </div>
              </a>
            </div>
            <div className="project">
              <div className="info">
                <div className="details">
                  <div>
                    <img src= {objectgif} alt="Icon" id="icon"></img>
                  </div>

                  <div className="filedetails">
                    <Info></Info>
                  </div>
                  {link.includes("mp3") ? <Downloadmenu link={link} menu={1}></Downloadmenu> : null}
                </div>
               
            
              </div>
              
              <div className="text">
                <h1 className="centerelements">{data[0].name}</h1>

                <p>{data[0].description}</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
